module.exports = __webpack_public_path__ + "static/images/section3img.0c095e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/section3img.png
// module id = ms5Q
// module chunks = 1